import genericStore from '../generic_store';
import axios from 'axios';
import { config } from '@/config/constants.js';

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: 'users',
    object: 'professionals',
    header: [
      { text: 'Foto de Perfil', value: 'profile_picture' },
      { text: 'Nombres', value: 'first_name' },
      { text: 'Apellidos', value: 'last_name' },
      { text: 'Email', value: 'email' },
      { text: 'Especialidad', value: 'speciality' },
      { text: 'Creditos', value: 'credits' },
    ],
    types: [{ id: 'professional', name: 'Profesional' }],
    options: {
      sortBy: ['_id'],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    getList({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit('request');

        const url = `${config.api_url}${state.endpoint}/${options.user_id}/professionals`;

        axios
          .get(url)
          .then((response) => {
            const map = {};
            response.data.forEach((element) => {
              if (element.speciality_id && !map[element.speciality_id]) {
                map[element.speciality_id] = element;
              }
            });

            const professionals = [];

            for (let key in map) {
              const element = map[key];
              const professional = { ...element.professional_id };
              professional.credits = element.credits || 0;

              if (
                professional.speciality_id &&
                Array.isArray(professional.speciality_id)
              ) {
                const matchedSpeciality = professional.speciality_id.find(
                  (spec) =>
                    spec._id?.toString() === element.speciality_id?.toString()
                );

                if (matchedSpeciality) {
                  professional.speciality_id = [matchedSpeciality];
                } else {
                  professional.speciality_id = [];
                }
              }

              professionals.push(professional);
            }

            commit('success', {
              list: professionals,
              total: professionals.length,
            });
            resolve(response.data);
          })
          .catch((err) => {
            commit('error');
            reject(err);
          });
      });
    },
    updateCredits({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit('request');
        const url = `${config.api_url}${state.endpoint}/${data.userId}/professionals/${data.professionalId}/specialities/${data.specialityId}/credits`;
        axios
          .post(url)
          .then((response) => {
            commit('success', response.data);
            resolve(response.data);
          })
          .catch((err) => {
            commit('error');
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
